<template>
  <div>
    <base-title-bar-scroll-page ref="container" :show-title-bar="!hideTitle" title="脊柱侧弯患者信息录入">
      <my-img style="width: 100%" url="https://cdn.keihong.tech/img/202411191109635.png"/>

      <van-cell-group>
        <van-cell :title="questionnaire.title"/>
        <van-cell>
          <p>{{ questionnaire.description }}</p>
        </van-cell>
      </van-cell-group>

      <van-form @submit="onSubmit">
        <div v-for="(question, index) in questionnaire.questions" :key="question.id" :data-question-id="question.id">
          <QuestionItem
            v-model="answers[question.id]"
            :question="question"
          />
        </div>
        <div style="padding: 16px">
          <van-button block native-type="submit" round type="primary">提交患者信息</van-button>
        </div>
      </van-form>
    </base-title-bar-scroll-page>
  </div>
</template>

<script>
import BaseTitleBarScrollPage from '@/h5/doucan/components/BaseTitleBarScrollPage.vue'
import MyImg from '@/h5/doucan/components/MyImg.vue'
import QuestionItem from '@/h5/doucan/components/Questionnaire/QuestionItem.vue'
import QuestionnaireDao from '@/h5/doucan/network/QuestionnaireDao'
import { Dialog } from 'vant'

export default {
  name: 'ShunyiPatientInfoTable',
  components: {
    QuestionItem,
    MyImg,
    BaseTitleBarScrollPage
  },
  data () {
    return {
      questionnaireId: 25, // 脊柱侧弯专用问卷ID
      hideTitle: false,
      questionnaire: {
        title: '脊柱侧弯患者基础信息采集',
        description: '为了给您提供更精准的脊柱侧弯康复方案，请详细填写以下信息。所有信息将严格保密，仅用于医疗康复目的。',
        questions: [
          {
            id: 1,
            order: 1,
            content: '患者姓名',
            type: 'text',
            required: true,
            placeholder: '请输入患者真实姓名'
          },
          {
            id: 2,
            order: 2,
            content: '患者性别',
            type: 'single_choice',
            required: true,
            options: [
              { id: 1, content: '男' },
              { id: 2, content: '女' }
            ]
          },
          {
            id: 3,
            order: 3,
            content: '患者年龄',
            type: 'text',
            required: true,
            placeholder: '请输入患者年龄（如：15岁）'
          },
          {
            id: 4,
            order: 4,
            content: '联系电话',
            type: 'text',
            required: true,
            placeholder: '请输入家长或患者联系电话'
          },
          {
            id: 5,
            order: 5,
            content: '身高体重',
            type: 'text',
            required: true,
            placeholder: '请输入身高和体重（如：165cm，50kg）'
          },
          {
            id: 6,
            order: 6,
            content: '脊柱侧弯发现时间',
            type: 'single_choice',
            required: true,
            options: [
              { id: 1, content: '最近3个月内' },
              { id: 2, content: '3-6个月前' },
              { id: 3, content: '6个月-1年前' },
              { id: 4, content: '1-2年前' },
              { id: 5, content: '2年以上' }
            ]
          },
          {
            id: 7,
            order: 7,
            content: '脊柱侧弯程度（如已检查）',
            type: 'single_choice',
            required: false,
            options: [
              { id: 1, content: '轻度（10-20度）' },
              { id: 2, content: '中度（20-40度）' },
              { id: 3, content: '重度（40度以上）' },
              { id: 4, content: '未进行专业检查' }
            ]
          },
          {
            id: 8,
            order: 8,
            content: '主要症状表现',
            type: 'multiple_choice',
            required: true,
            options: [
              { id: 1, content: '肩膀一高一低' },
              { id: 2, content: '背部不对称' },
              { id: 3, content: '腰部疼痛' },
              { id: 4, content: '背部疼痛' },
              { id: 5, content: '颈部疼痛' },
              { id: 6, content: '行走姿势异常' },
              { id: 7, content: '容易疲劳' },
              { id: 8, content: '呼吸困难' },
              { id: 9, content: '暂无明显症状' }
            ]
          },
          {
            id: 9,
            order: 9,
            content: '既往治疗经历',
            type: 'multiple_choice',
            required: false,
            options: [
              { id: 1, content: '物理治疗' },
              { id: 2, content: '按摩推拿' },
              { id: 3, content: '佩戴矫正器' },
              { id: 4, content: '运动康复' },
              { id: 5, content: '手术治疗' },
              { id: 6, content: '中医治疗' },
              { id: 7, content: '无治疗经历' }
            ]
          },
          {
            id: 10,
            order: 10,
            content: '家族病史',
            type: 'single_choice',
            required: true,
            options: [
              { id: 1, content: '有家族脊柱侧弯病史' },
              { id: 2, content: '无家族脊柱侧弯病史' },
              { id: 3, content: '不确定' }
            ]
          },
          {
            id: 11,
            order: 11,
            content: '日常活动受限情况',
            type: 'single_choice',
            required: true,
            options: [
              { id: 1, content: '无影响' },
              { id: 2, content: '轻微影响' },
              { id: 3, content: '中度影响' },
              { id: 4, content: '严重影响' }
            ]
          },
          {
            id: 12,
            order: 12,
            content: '运动习惯',
            type: 'multiple_choice',
            required: false,
            options: [
              { id: 1, content: '游泳' },
              { id: 2, content: '瑜伽' },
              { id: 3, content: '跑步' },
              { id: 4, content: '球类运动' },
              { id: 5, content: '舞蹈' },
              { id: 6, content: '健身房锻炼' },
              { id: 7, content: '无固定运动习惯' }
            ]
          },
          {
            id: 13,
            order: 13,
            content: '脊柱侧弯相关影像资料',
            type: 'file',
            required: false,
            description: '如有X光片、CT或MRI等影像资料，请上传以便专业评估'
          },
          {
            id: 14,
            order: 14,
            content: '其他补充信息',
            type: 'text',
            required: false,
            placeholder: '请描述其他您认为重要的相关信息'
          }
        ]
      },
      answers: {}, // 用于存储用户填写的答案
      lastAnswer: null,
      openId: '',
      isWxapp: false,
      userGender: '', // 用户性别
      thirdPartyUserId: '', // 第三方系统用户ID
      userName: '', // 用户姓名
      userPhone: '' // 用户电话
    }
  },
  async mounted () {
    const query = this.$route.query

    console.log('患者信息录入页面参数:', query)

    if (query.from === 'wxapp') {
      this.isWxapp = true
      this.hideTitle = true
      this.openId = query.openid
    }

    // 处理新增参数
    this.userGender = query.gender || ''
    this.thirdPartyUserId = query.userId || ''
    this.userName = query.name || ''
    this.userPhone = query.phone || ''

    // 预填充基础信息
    if (this.userName) {
      this.answers[1] = this.userName // 预填充患者姓名
    }
    if (this.userGender) {
      // 根据性别设置单选项 (1=男, 2=女)
      this.answers[2] = this.userGender === '男' ? 1 : (this.userGender === '女' ? 2 : null)
    }
    if (this.userPhone) {
      this.answers[4] = this.userPhone // 预填充联系电话
    }

    await this.getNewestAnswer()
    this.hideLoading()
  },
  methods: {
    hideLoading () {
      this.$refs.container.stopLoading()
    },
    async onSubmit () {
      console.log('提交的答案:', this.answers)

      // 检查必填项
      const unansweredQuestions = this.questionnaire.questions.filter(
        question => question.required && !this.answers[question.id]
      )

      if (unansweredQuestions.length > 0) {
        const firstUnanswered = unansweredQuestions[0]
        this.$toast.fail(`请完成必填项目: ${firstUnanswered.order}、${firstUnanswered.content}`)
        this.scrollToQuestion(firstUnanswered.id)
        return
      }

      // 上传文件处理
      for (const questionId in this.answers) {
        const question = this.questionnaire.questions.find(q => q.id === parseInt(questionId))
        const value = this.answers[questionId]

        if (question && question.type === 'file' && value) {
          const uploadedUrls = []
          for (var i in value) {
            if (value[i].status === 'success') {
              uploadedUrls.push(value[i].url)
              continue
            }

            const file = value[i].file
            const result = await this.uploadToAliyun(file, i)
            var uploadedUrl = result.res.requestUrls[0]
            uploadedUrl = uploadedUrl.includes('?uploadId') ? uploadedUrl.substring(0, uploadedUrl.indexOf('?')) : uploadedUrl

            if (uploadedUrl.startsWith('http:')) {
              uploadedUrl = uploadedUrl.replace('http:', 'https:')
            }
            uploadedUrls.push(uploadedUrl)
          }
          this.answers[questionId] = uploadedUrls
        }
      }

      // 提交数据
      const body = this.transformData(this.answers)
      console.log('提交答案 body', body)

      try {
        const res = await QuestionnaireDao.submitAnswer(body)
        console.log('提交返回结果', res)

        if (res.code === 200) {
          Dialog.alert({
            title: '提交成功',
            message: '患者信息已成功录入，我们的专业团队将在24小时内联系您，为您制定个性化的脊柱侧弯康复方案。'
          }).then(() => {
            if (this.isWxapp) {
              window.wx.miniProgram.switchTab({
                url: '/pages/index/index'
              })
            } else {
              this.$router.push('/Shunyi/home')
            }
          })
        }
      } catch (error) {
        console.error('提交失败:', error)
        this.$toast.fail('提交失败，请重试')
      }
    },
    scrollToQuestion (questionId) {
      this.$nextTick(() => {
        const questionElement = document.querySelector(`[data-question-id="${questionId}"]`)
        if (questionElement) {
          questionElement.scrollIntoView({
            behavior: 'smooth',
            block: 'center'
          })
        }
      })
    },
    transformData (rawData) {
      const transformedData = {
        questionnaireId: this.questionnaireId,
        userId: '',
        openId: this.openId,
        thirdPartyUserId: this.thirdPartyUserId, // 新增第三方用户ID
        userGender: this.userGender, // 新增用户性别
        userName: this.userName, // 新增用户姓名
        userPhone: this.userPhone, // 新增用户电话
        answers: []
      }

      Object.entries(rawData).forEach(([key, value]) => {
        const questionId = parseInt(key, 10)
        const answer = { questionId }

        if (typeof value === 'string') {
          answer.content = value
        } else if (typeof value === 'number') {
          answer.optionId = value
        } else if (Array.isArray(value)) {
          var isFileUrl = false

          for (const content of value) {
            if (typeof content === 'string' && content.startsWith('http')) {
              answer.content = content
              isFileUrl = true
              break
            }
          }

          if (isFileUrl) {
            answer.content = JSON.stringify(value)
          } else {
            answer.optionIds = value
          }
        }

        transformedData.answers.push(answer)
      })

      return transformedData
    },
    async getNewestAnswer () {
      try {
        const result = await QuestionnaireDao.getSubmitHistory(this.openId)
        if (result && result.length > 0) {
          const newestQuestionnaires = result[result.length - 1]
          this.lastAnswer = await QuestionnaireDao.getAnswersByResponseId(newestQuestionnaires.responseId)
          this.initializeAnswers(this.lastAnswer.questions)
        }
      } catch (error) {
        console.log('获取历史答案失败:', error)
      }
    },
    initializeAnswers (lastAnswer) {
      lastAnswer.forEach(question => {
        if (question.type === 'text') {
          this.answers[question.id] = question.answer || ''
        } else if (question.type === 'single_choice') {
          this.answers[question.id] = question.answer || null
        } else if (question.type === 'multiple_choice') {
          this.answers[question.id] = question.answer || []
        } else if (question.type === 'file') {
          if (question.answer) {
            const parsed = JSON.parse(question.answer)
            this.answers[question.id] = this.convertUrlsToUploaderFiles(parsed)
          } else {
            this.answers[question.id] = []
          }
        }
      })
    },
    convertUrlsToUploaderFiles (urls) {
      return urls.map((url, index) => ({
        name: `影像资料${index + 1}`,
        url: url,
        status: 'success'
      }))
    },
    async uploadToAliyun (file, index) {
      const OSS = require('ali-oss')
      const ossConfig = {
        region: 'oss-cn-shenzhen',
        accessKeyId: 'LTAIAcClE56I1mY0',
        accessKeySecret: 'IIPoiW0o3noCHU9bRT5vyAw0EDtem8',
        bucket: 'ihealthy'
      }

      const client = new OSS(ossConfig)
      const filename = new Date().getTime() + '_' + file.name
      const path = `spine_questionnaire/${this.questionnaireId}/` + filename

      console.log('上传文件', path)

      const ret = await client.multipartUpload(path, file, {
        progress: (p) => {
          console.log(`上传进度: 第${index + 1}个文件 - ${parseInt(p * 100)}%`)
        }
      })

      return ret
    }
  }
}
</script>

<style scoped>
:deep(.van-cell-group) {
  margin: 16px;
  border-radius: 8px;
  overflow: hidden;
}

:deep(.van-cell) {
  padding: 12px 16px;
}

:deep(.van-form) {
  padding: 0 16px;
}

:deep(.van-field) {
  margin-bottom: 12px;
  border-radius: 8px;
  background: white;
}

:deep(.van-button) {
  font-size: 16px;
  font-weight: 600;
}

.questionnaire-container {
  background: #f7f8fa;
  min-height: 100vh;
}
</style>
